import { createSelector } from 'reselect'

import selectIntegrationCredentialsBase from './selectIntegrationCredentialsBase'

export default createSelector(
  selectIntegrationCredentialsBase,
  credentials => credentials.loaded
)
